
import './footer.css';

import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faInstagram,
  faLinkedinIn,
  faFacebookF,
  faTiktok,
} from '@fortawesome/free-brands-svg-icons';

import logo from '../header/images/logo.png';

export const Footer = () => {
  return (
    <footer className="footer-modern">

      <div className="footer-content">

        {/* =====================================
            CONTALEARN
        ===================================== */}

        <div className="footer-column footer-brand-column">

          <Link to="/" className="footer-logo">
            <img
              src={logo}
              alt="ContaLearn"
              className="footer-logo-image"
            />
          </Link>

          <p className="footer-description">
            Invata contabilitatea simplu si practic.
          </p>

          <div className="footer-social">

            <a
              href="https://www.instagram.com/conta_learn/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>

            <a
              href="https://www.linkedin.com/company/contalearn"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FontAwesomeIcon icon={faLinkedinIn} />
            </a>

            <a
              href="#"
              aria-label="Facebook"
            >
              <FontAwesomeIcon icon={faFacebookF} />
            </a>

            <a
              href="https://www.tiktok.com/@contalearn"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="TikTok"
            >
              <FontAwesomeIcon icon={faTiktok} />
            </a>

          </div>

          {/* =====================================
              DATELE FIRMEI
          ===================================== */}

          <div className="footer-company-details">
            <p>© 2026 CONTALEARN SRL</p>
            <p>CUI: 55705840</p>
            <p>Nr. ord. reg.: J2026057859008</p>
          </div>

        </div>

        {/* =====================================
            PRODUS
        ===================================== */}

        <div className="footer-column">

          <h4>Produs</h4>

          <ul className="footer-links">

            <li>
              <Link to="/cursuri-prezentare">
                Cursuri
              </Link>
            </li>

            <li>
              <Link to="/viewplans">
                Preturi
              </Link>
            </li>

            <li>
              <Link to="/certification">
                Certificare
              </Link>
            </li>

          </ul>

        </div>

        {/* =====================================
            RESURSE
        ===================================== */}

        <div className="footer-column">

          <h4>Resurse</h4>

          <ul className="footer-links">

           <li>
  <Link to="/forum-in-lucru">
    Forum
  </Link>
</li>

            <li>
              <Link to="/blog">
                Blog
              </Link>
            </li>

            <li>
              <Link to="/FAQ">
                Intrebari frecvente
              </Link>
            </li>

          </ul>

        </div>

        {/* =====================================
            COMPANIE
        ===================================== */}

        <div className="footer-column">

          <h4>Companie</h4>

          <ul className="footer-links">

            <li>
              <Link to="/about">
                Despre noi
              </Link>
            </li>

            <li>
              <Link to="/ajutor">
                Contact
              </Link>
            </li>

            <li>
              <Link to="/feedback">
                Trimite feedback
              </Link>
            </li>

          </ul>

        </div>

        {/* =====================================
            LEGAL
        ===================================== */}

        <div className="footer-column">

          <h4>Legal</h4>

          <ul className="footer-links">

            <li>
              <Link to="/Termeni">
                Termeni si conditii
              </Link>
            </li>

            <li>
              <Link to="/Politica">
                Politica de confidentialitate
              </Link>
            </li>

            <li>
              <Link to="/Politicacookies">
                Politica de cookie-uri
              </Link>
            </li>

            <li>
              <Link to="/gdpr">
                Protectia datelor
              </Link>
            </li>

            <li>
              <Link to="/anpc">
                Protectia consumatorului
              </Link>
            </li>

          </ul>

        </div>

      </div>

      {/* =====================================
          ANPC - SAL SI SOL
      ===================================== */}

      <div className="footer-anpc">

        <a
          href="https://reclamatiisal.anpc.ro/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="ANPC - Solutionarea Alternativa a Litigiilor"
        >
          <img
            src="/images/anpc-sal.webp"
            alt="ANPC - SAL"
            className="footer-anpc-image"
          />
        </a>

        <a
          href="https://consumer-redress.ec.europa.eu/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Informatii europene privind solutionarea litigiilor"
        >
          <img
            src="/images/anpc-sol.webp"
            alt="ANPC - SOL"
            className="footer-anpc-image"
          />
        </a>

      </div>

      {/* =====================================
          BOTTOM
      ===================================== */}

      <div className="footer-bottom">

        <div className="footer-bottom-content">

          <p>
            © 2026 CONTALEARN SRL. Toate drepturile rezervate.
          </p>

          <p>
            Made with ❤️ in Romania
          </p>

        </div>

      </div>

    </footer>
  );
};
